module.exports = __webpack_public_path__ + "img/yahoo.5970e9be.svg";